export const STORAGE_KEYS = {
  INVITATION_RETURN_URL: 'gd_invitation_return_url'
} as const;
